<form [formGroup]="form" autocomplete="off">
  <h3 class="tw-mt-[25px] tw-mb-4 mdi mdi-arrow-left ltr:mdi-arrow-right">
    {{ pageVocabs + "legends.personalInformation" | translate }}
  </h3>

  <!-- isForeigner -->
  <div class="row">
    <div class="tw-w-full">
      <div class="checkbox-section tw-ml-2 tw-mb-2">
        <mat-slide-toggle
          formControlName="isForeigner"
          [(ngModel)]="model.isForeigner"
          (change)="changePersonalInformationValidators(); emitForm()"
        >
          {{ "common.isForeigner" | translate }}</mat-slide-toggle
        >
      </div>
    </div>
  </div>

  <!-- personalInformation -->
  <div class="row">
    <!-- firstName -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.firstName"
        (valueChange)="model.firstName = $event; emitForm()"
        [control]="form?.get('firstName')"
        label="common.firstName"
        [maxLength]="32"
      >
      </form-field>
    </div>

    <!-- lastName -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.lastName"
        (valueChange)="model.lastName = $event; emitForm()"
        [control]="form?.get('lastName')"
        label="common.lastName"
        [maxLength]="32"
      >
      </form-field>
    </div>

    <!-- fatherName -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.fatherName"
        (valueChange)="model.fatherName = $event; emitForm()"
        [control]="form?.get('fatherName')"
        label="common.fatherName"
        [maxLength]="32"
      >
      </form-field>
    </div>

    <!-- birthDate -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <datepicker
        [value]="model.birthDate"
        (value)="model.birthDate = $event; emitForm()"
        [control]="form?.get('birthDate')"
        label="common.birthDate"
        (onErrorDatePicker)="showErrorDialog($event)"
      >
      </datepicker>
    </div>

    <!-- nationalCode -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.nationalCode"
        (valueChange)="model.nationalCode = $event; emitForm()"
        [control]="form?.get('nationalCode')"
        [label]="
          !model.isForeigner
            ? 'common.nationalCode'
            : (fields + 'foreignerCode' | translate)
        "
        [minLength]="model.isForeigner ? 12 : 10"
        [maxLength]="model.isForeigner ? 12 : 10"
        type="tel"
      >
      </form-field>
    </div>

    <!-- identityNumber -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4" *ngIf="!model.isForeigner">
      <form-field
        [value]="model.identityNumber"
        (valueChange)="model.identityNumber = $event; emitForm()"
        [control]="form?.get('identityNumber')"
        label="common.identityNumber"
        type="tel"
        [maxLength]="10"
      >
      </form-field>
    </div>

    <!-- phone -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.phone"
        (valueChange)="model.phone = $event; emitForm()"
        [control]="form?.get('phone')"
        label="common.phone"
        type="tel"
        [maxLength]="11"
      >
      </form-field>
    </div>

    <!-- faxNumber -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.faxNumber"
        (valueChange)="model.faxNumber = $event; emitForm()"
        [control]="form?.get('faxNumber')"
        label="common.faxNumber"
        type="tel"
        [maxLength]="11"
      >
      </form-field>
    </div>

    <!-- mobile -->
    <div
      class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4"
      *ngIf="!model.mobile || !formPageConfig.isEditMode"
    >
      <form-field
        [value]="model.mobile"
        (valueChange)="model.mobile = $event; emitForm()"
        [control]="form?.get('mobile')"
        label="common.mobile"
        type="tel"
        [maxLength]="12"
      >
      </form-field>
    </div>

    <!-- country -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <zones-select-search
        label="common.state"
        class="tw-w-full"
        type="byZoneType"
        [id]="selectedCountry"
        [zoneType]="ZoneType.Country"
        [control]="form?.get('country')"
        [value]="selectedCountry"
        (valueChange)="onChangeZones($event, 'states'); emitForm()"
        (onError)="onClose()"
      >
      </zones-select-search>
    </div>

    <!-- state -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <zones-select-search
        label="common.state"
        class="tw-w-full"
        [id]="selectedCountry"
        [control]="form?.get('state')"
        [value]="selectedState"
        (valueChange)="onChangeZones($event, 'cities'); emitForm()"
        (onError)="onClose()"
      >
      </zones-select-search>
    </div>

    <!--city(zoneId) -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <zones-select-search
        label="common.city"
        class="tw-w-full"
        [id]="selectedState"
        [control]="form?.get('zoneId')"
        [value]="selectedState ? model.zoneId : null"
        (valueChange)="selectedState ? (model.zoneId = $event) : ''; emitForm()"
        (onError)="onClose()"
      >
      </zones-select-search>
    </div>

    <!-- zipCode -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.zipCode"
        (valueChange)="model.zipCode = $event; emitForm()"
        [control]="form?.get('zipCode')"
        label="common.zipCode"
        type="tel"
        [maxLength]="10"
      >
      </form-field>
    </div>

    <!-- address -->
    <div class="md:tw-w-1/2">
      <form-textarea
        class="tw-w-full"
        label="common.address"
        [(value)]="model.address"
        [control]="form?.get('address')"
        [rows]="1"
        (valueChange)="emitForm()"
      >
      </form-textarea>
    </div>
  </div>

  <h3 class="tw-mt-2 tw-mb-4 mdi mdi-arrow-left ltr:mdi-arrow-right">
    {{ pageVocabs + "legends.systemInformation" | translate }}
  </h3>

  <!-- system Information -->
  <div class="row">
    <!-- checkBoxes  -->
    <div class="row tw-mt-3">
      <!-- isActiveSend -->
      <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
        <mat-slide-toggle
          formControlName="isActiveSend"
          [(ngModel)]="model.isActiveSend"
          (change)="emitForm()"
        >
          {{ "common.isActiveSend" | translate }}</mat-slide-toggle
        >
      </div>

      <!-- isActive -->
      <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
        <mat-slide-toggle
          formControlName="isDefault"
          [(ngModel)]="model.isDefault"
        >
          {{ "common.isActive" | translate }}</mat-slide-toggle
        >
      </div>

      <!-- isCanSeeContactsOfPublicPhonebooks -->
      <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
        <mat-slide-toggle
          formControlName="isCanSeeContactsOfPublicPhonebooks"
          [(ngModel)]="model.isCanSeeContactsOfPublicPhonebooks"
          [disabled]="isAdmin && !permissionService.userState()?.isSuperAdmin"
        >
          {{
            fields + "isCanSeeContactsOfPublicPhonebooks" | translate
          }}</mat-slide-toggle
        >
      </div>

      <!-- isCanSeeContactsOfPrivatePhonebooks -->
      <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
        <mat-slide-toggle
          formControlName="isCanSeeContactsOfPrivatePhonebooks"
          [(ngModel)]="model.isCanSeeContactsOfPrivatePhonebooks"
          [disabled]="isAdmin && !permissionService.userState()?.isSuperAdmin"
        >
          {{
            fields + "isCanSeeContactsOfPrivatePhonebooks" | translate
          }}</mat-slide-toggle
        >
      </div>

      <!-- isCanSendSmartWithoutConfirmation -->
      <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
        <mat-slide-toggle
          formControlName="isCanSendSmartWithoutConfirmation"
          [(ngModel)]="model.isCanSendSmartWithoutConfirmation"
        >
          {{
            "common.isCanSendSmartWithoutConfirmation" | translate
          }}</mat-slide-toggle
        >
      </div>

      <!-- isSendSmsDescriptionRequired -->
      <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
        <mat-slide-toggle
          formControlName="isSendSmsDescriptionRequired"
          [(ngModel)]="model.isSendSmsDescriptionRequired"
        >
          {{
            fields + "isSendSmsDescriptionRequired" | translate
          }}</mat-slide-toggle
        >
      </div>
    </div>

    <!-- userName -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.userName"
        (valueChange)="model.userName = $event; emitForm()"
        [control]="form?.get('userName')"
        label="common.userName"
        [maxLength]="32"
      >
      </form-field>
    </div>

    <!-- descriptions -->
    <div class="md:tw-w-full lg:tw-w-1/2">
      <form-textarea
        class="tw-w-full"
        label="common.description"
        [(value)]="model.descriptions"
        [control]="form?.get('descriptions')"
        [rows]="1"
        (valueChange)="emitForm()"
      >
      </form-textarea>
    </div>

    <!-- email -->
    <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
      <form-field
        [value]="model.email"
        (valueChange)="model.email = $event; emitForm()"
        [control]="form?.get('email')"
        label="common.email"
      >
      </form-field>
    </div>

    <ng-container>
      <div class="sm:tw-w-full lg:tw-w-2/3 xl:tw-w-1/2">
        <app-date-time-picker
          [config]="dateTimeConfig"
          (dateTime)="model.expireDate = $event; emitForm()"
        >
        </app-date-time-picker>
      </div>

      <div class="lg:tw-w-2/3 xl:tw-w-1/2">
        <!-- password & confirm password -->
        <app-set-password
          class="tw-w-full"
          responsiveClass="md:tw-w-1/2"
          [isRequired]="formPageConfig.isEditMode ? false : true"
          [isRefreshForm]="isRefreshForm"
          [isDisabledForm]="!isEnableSystemInfo() ? true : false"
          (password)="model.password = $event; emitForm()"
          (form)="passwordForm = $event"
          (isRefreshForm)="isRefreshForm = $event"
        >
        </app-set-password>
      </div>
    </ng-container>
  </div>
</form>
